<div #el>
    <ax-text-box > 
        <ax-button  >
             <i class="fas fa-list"></i> 
        </ax-button>
    </ax-text-box>
</div>